module.exports = __webpack_public_path__ + "img/9_l_no.bf1249dd.svg";